var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdc-menu mdc-menu-surface",on:{"MDCMenu:selected":_vm.onSelect}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }